import React, { useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import AntLayout from 'components/Layout';
import AppRoutes from '../Routing'; // Renamed to avoid confusion with react-router Route
import ChangePassword from 'pages/ChangePassword/ChangePassword';
import Login from 'components/Login';
import NotFound from 'pages/404';
import ErrorPage from 'pages/404/error'; // Renamed to avoid confusion with JavaScript Error
import { useQuery } from 'react-query';
import { getCurrentUserMenu } from 'services/displayFramework';
import { isNil } from 'lodash';
import { message } from 'antd';
import getEnvValue from 'utils/getEnvValue';
import AntLayoutSFS from 'components/theme_components/Layout';

export const AuthContext = React.createContext({
  token: null,
  setToken: () => null,
  menu: [],
} as any);

const Auth: React.FC = () => {
  const [token, setToken] = useState(() => localStorage.getItem('token'));

  const [changePassword, setchangePassword] = useState(() =>
    localStorage.getItem('changepassword')
  );
  const [inspect, setInspect] = useState(false);

  const { data: menu, isFetching } = useQuery(
    ['getCrrentUserMenu', { token }],
    async () => await getCurrentUserMenu().then((res) => res?.list || []),
    { enabled: !isNil(token) }
  );

  const setTokenInLocal = (token: string) => {
    localStorage.setItem('token', token);
    setToken(token);
  };

  useEffect(() => {
    setchangePassword(localStorage.getItem('changepassword'));
    setToken(localStorage.getItem('token'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localStorage.getItem('token'), localStorage.getItem('changepassword')]);

  const setInspectMode = (modeInspect: boolean) => {
    if (modeInspect === true) message.info('Ispect mode is ON', 5);
    else message.info('Inspect mode is OFF', 5);
    setInspect(modeInspect);
  };



  return (
    <AuthContext.Provider
      value={{
        token,
        setToken: setTokenInLocal,
        menu: menu,
        isFetching,
        setInspectMode,
        isInspect: inspect,
      }}
    >
      <Router>
        <Routes>
          <Route path="/pageNotFound" element={<NotFound />} />
          <Route path="/404" element={<ErrorPage />} />
          <Route path="/init_change_password" element={<AntLayout><ChangePassword isInit /></AntLayout>} />
          {token && (changePassword === 'false' || changePassword == null) && menu ? (
            <Route path="*" element={
              getEnvValue('layoutStandard')
                ? <AntLayout><AppRoutes /></AntLayout> : <AntLayoutSFS><AppRoutes /></AntLayoutSFS>


            } />
          ) : (
            !(
              token &&
              (changePassword === 'false' || changePassword == null)
            ) && (
              <>
                <Route path="/login" element={<Login />} />

                {changePassword === 'true' ? (
                  <Route path="*" element={<Navigate to="/init_change_password" />} />
                ) : (
                  <Route path="*" element={<Navigate to="/login" />} />
                )}
              </>
            ))}
        </Routes>
      </Router>
    </AuthContext.Provider>
  );
};

export default Auth;
